import React from "react";
import { Button, Form, Input, message, Modal } from "antd";
import { connect } from "react-redux";

import { fetchOrg, forgotPassword, userSignIn } from "../appRedux/actions/Auth";
import IntlMessages from "util/IntlMessages";

const FormItem = Form.Item;

class SignIn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalVisible: false,
    };
  }

  componentDidMount() {
    this.props.fetchOrg(window.location.host.split('.')[0]);
    try {
      // Set by util/Api when the backend rejects the stored token
      if (sessionStorage.getItem('sessionExpired')) {
        sessionStorage.removeItem('sessionExpired');
        message.info('Your session has expired, please login again', 5);
      }
    } catch (e) {
      // Ignore storage errors
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (process.env.REACT_APP_ENVIRONMENT === 'development') {
          this.props.userSignIn({ ...values });
        } else {
          this.props.userSignIn({ organisation: window.location.host.split('.')[0], ...values });
        }
      }
    });
  };

  componentDidUpdate() {
    if (this.props.token !== null) {
      if (this.props && this.props.location && this.props.location.state && this.props.location.state.from && this.props.location.state.from.pathname) {
        const { pathname, search } = this.props.location.state.from;
        this.props.history.push(search ? pathname + search : pathname);
      } else {
        this.props.history.push('/');
      }
    }
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.forgetPasswordStatus && this.props.forgetPasswordStatus !== nextProps.forgetPasswordStatus) {
      this.setState({
        modalVisible: false,
      });
    }
  }

  openModal() {
    this.setState({
      modalVisible: true,
    });
  }

  closeModal() {
    this.setState({
      modalVisible: false,
    });
  }

  handleForgotPassword(e) {
    e.preventDefault();
    if (e.target.email.value) {
      this.props.forgotPassword({ email: e.target.email.value, organisation: window.location.host.split('.')[0] });
    } else {
      message.error('Please enter a valid email to continue!');
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { orgData } = this.props;
    return (
      <div className="gx-app-login-wrap">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-content-bg">
                {/*<img src="https://via.placeholder.com/272x395" alt='Neature'/>*/}
              </div>
              <div className="gx-app-logo-wid">
                <h1><IntlMessages id="app.userAuth.signIn" /></h1>
                <p>{(orgData && orgData.name) || <IntlMessages id="app.userAuth.bySigning" />}</p>
              </div>
              <div className="gx-app-logo">
                <img alt={'AssetPro - ' + (orgData && orgData.name)} src={(orgData && orgData.logo) || 'icons/Logo-Assetpro.png'} />
              </div>
            </div>
            <div className="gx-app-login-content">
              <Form onSubmit={this.handleSubmit} className="gx-signin-form gx-form-row0">
                {process.env.REACT_APP_ENVIRONMENT === 'development' && (
                  <FormItem>
                    {getFieldDecorator('organisation', {
                      rules: [{ required: true, message: 'Please input your organization!' }],
                      initialValue: window.location.host.split('.')[0]
                    })(
                      <Input placeholder="Organization" />
                    )}
                  </FormItem>
                )}
                <FormItem>
                  {getFieldDecorator('email', {
                    rules: [{
                      required: true, type: 'email', message: 'The input is not valid e-mail!',
                    }],
                  })(
                    <Input placeholder="Email" />
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('password', {
                    rules: [{ required: true, message: 'Please input your password!' }],
                  })(
                    <Input.Password placeholder="Password" />
                  )}
                </FormItem>
                <FormItem>
                  <Button type="primary" className="gx-mb-0" htmlType="submit">
                    <IntlMessages id="app.userAuth.signIn" />
                  </Button>
                </FormItem>
                <span><a onClick={this.openModal.bind(this)}>Forgot Password?</a></span>
                <br /><br />
                <span className="gx-text-light gx-fs-sm">
                  Please contact administrator if you have need assistance with login!
                </span>
              </Form>
              <Modal
                centered={true}
                title="Forgot Password"
                visible={this.state.modalVisible}
                onCancel={this.closeModal.bind(this)}
                footer={[
                  <Button key="cancel" htmlType="reset" onClick={this.closeModal.bind(this)}>Cancel</Button>,
                  <Button type={"primary"} loading={this.props.loading} form="myForm" key="submit" htmlType="submit">
                    Submit
                  </Button>
                ]}
              >
                <form id="myForm" onSubmit={this.handleForgotPassword.bind(this)}>
                  <Input placeholder="Enter Email" name={'email'} />
                </form>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(SignIn);

const mapStateToProps = ({ auth, commonData }) => {
  const { token, forgetPasswordStatus, orgData } = auth;
  const { error, loading } = commonData;
  const displayMessage = commonData.message;
  return { token, forgetPasswordStatus, error, loading, displayMessage, orgData }
};

function mapDispatchToProps(dispatch) {
  return {
    userSignIn,
    forgotPassword,
    fetchOrg
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(WrappedNormalLoginForm);
